<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      v-if="showMain"
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_REGION_ID'
        )
      }"
    >
      <p class="content-s-2-label">
        <label>Укажите регион Российской Федерации:</label>
      </p>
      <select
        v-on:change="
          $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_REGION_ID');
          $parent.project.UF_MONOGOROD_ID = '';
        "
        v-model="$parent.project.UF_REGION_ID"
        class="sel-dropdown i-main-style i-wid-29"
        :disabled="$parent.$parent.projectDisabled"
      >
        <option value=""></option>
        <option
          v-for="item in $parent.directory.regions"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-text="item.NAME"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText("PROJECTS", "LOGIC", "UF_REGION_ID")
        }}
      </div>
    </div>

    <p class="content-s-2-label" v-if="showMain">
      <label>{{ mainLabel }}</label>
    </p>
    <div
      v-if="showMain"
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_IS_MONOGOROD'
        )
      }"
    >
      <select
        v-on:change="
          $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_IS_MONOGOROD');
          $parent.project.UF_MONOGOROD_ID = '';
        "
        v-model="$parent.project.UF_IS_MONOGOROD"
        class="sel-dropdown i-main-style i-wid-29"
        :disabled="$parent.$parent.projectDisabled"
      >
        <option value="0">Город не входит в перечень моногородов</option>
        <option value="1">Город входит в перечнь моногородов</option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText("PROJECTS", "LOGIC", "UF_IS_MONOGOROD")
        }}
      </div>
    </div>
    <div
      v-if="showMain"
      class="col-xs-12 mycol content-mb-14"
      v-show="
        $parent.project.UF_IS_MONOGOROD === '0' ||
          $parent.project.UF_IS_MONOGOROD === 0 ||
          $parent.project.UF_IS_MONOGOROD === ''
      "
    >
      <p class="content-s-2-label">
        <label>Укажите город/населенный пункт:</label>
      </p>
      <div class="row myrow">
        <div
          class="col-xs-12 mycol"
          v-bind:class="{
            'has-error': $parent.$parent.checkErrorField(
              'PROJECTS',
              'LOGIC',
              'UF_CITY'
            )
          }"
        >
          <input
            v-on:keyup="
              $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_CITY')
            "
            type="text"
            class="i-main-style i-wid-29"
            v-model="$parent.project.UF_CITY"
            :disabled="$parent.$parent.projectDisabled"
          />
          <div class="error-text">
            {{ $parent.$parent.checkErrorText("PROJECTS", "LOGIC", "UF_CITY") }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showMain"
      class="col-xs-12 mycol"
      v-show="
        $parent.project.UF_IS_MONOGOROD === '1' ||
          $parent.project.UF_IS_MONOGOROD === 1
      "
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_MONOGOROD_ID'
        )
      }"
    >
      <p class="content-s-2-label">
        <label>Укажите город/населенный пункт:</label>
      </p>
      <select
        v-model="$parent.project.UF_MONOGOROD_ID"
        class="sel-dropdown i-main-style i-wid-29"
        :disabled="$parent.$parent.projectDisabled"
        @change="
          $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_MONOGOROD_ID')
        "
      >
        <option value=""></option>
        <option
          v-for="item in $parent.directory.sp_monogorod"
          :value="item.ID"
          :key="item.ID"
          v-text="item.NAME"
          v-if="item.ID_REGION === $parent.project.UF_REGION_ID"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText("PROJECTS", "LOGIC", "UF_MONOGOROD_ID")
        }}
      </div>
    </div>
    <div style="clear: both"></div>
    <br />
    <div style="clear: both"></div>

    <p class="content-s-2-label" style="padding-bottom: 10px;"
    v-if="showDop && (dopPlaces.length > 0 || !$parent.$parent.projectDisabled)">
      <label>{{ dopLabel }}</label>
    </p>
    <div v-for="(place, index) in dopPlacesVisible">
      <div class="col-xs-12 mycol content-mb-14">
        <p class="content-s-2-label">
          <label>Укажите регион Российской Федерации:</label>
        </p>
        <select
          v-on:change="place.UF_MONOGOROD_ID = ''"
          v-model="place.UF_REGION_ID"
          class="sel-dropdown i-main-style i-wid-29"
          :disabled="$parent.$parent.projectDisabled"
        >
          <option value=""></option>
          <option
            v-for="item in $parent.directory.regions"
            v-bind:value="item.ID"
            v-bind:key="item.ID"
            v-text="item.NAME"
          ></option>
        </select>
        <!--
        <div class="error-text">
          {{
            $parent.$parent.checkErrorText("PROJECTS", "LOGIC", "UF_REGION_ID")
          }}
        </div>
        -->
      </div>
      <p class="content-s-2-label">
        <label>{{ dopRowLabel }}</label>
      </p>
      <div class="col-xs-12 mycol content-mb-14">
        <select
          v-model="place.UF_IS_MONOGOROD"
          class="sel-dropdown i-main-style i-wid-29"
          :disabled="$parent.$parent.projectDisabled"
        >
          <option value="0">Город не входит в перечень моногородов</option>
          <option value="1">Город входит в перечнь моногородов</option>
        </select>
        <!--
        <div class="error-text">
          {{
            $parent.$parent.checkErrorText("PROJECTS", "LOGIC", "UF_IS_MONOGOROD")
          }}
        </div>
        -->
      </div>
      <div
        class="col-xs-12 mycol content-mb-14"
        v-show="
          place.UF_IS_MONOGOROD === '0' ||
            place.UF_IS_MONOGOROD === 0 ||
            place.UF_IS_MONOGOROD === ''
        "
      >
        <p class="content-s-2-label">
          <label>Укажите город/населенный пункт:</label>
        </p>
        <div class="row myrow">
          <div
            class="col-xs-12 mycol"
            v-bind:class="{
              'has-error11': $parent.$parent.checkErrorField(
                'PROJECTS',
                'LOGIC',
                'UF_CITY'
              )
            }"
          >
            <input
              type="text"
              class="i-main-style i-wid-29"
              v-model="place.UF_CITY"
            />
            <!--
            <div class="error-text">
              {{ $parent.$parent.checkErrorText("PROJECTS", "LOGIC", "UF_CITY") }}
            </div>
            -->
          </div>
        </div>
      </div>
      <div
        class="col-xs-12 mycol"
        v-show="place.UF_IS_MONOGOROD === '1' || place.UF_IS_MONOGOROD === 1"
        v-bind:class="{
          'has-error11': $parent.$parent.checkErrorField(
            'PROJECTS',
            'LOGIC',
            'UF_MONOGOROD_ID'
          )
        }"
      >
        <p class="content-s-2-label">
          <label>Укажите город/населенный пункт:</label>
        </p>
        <select
          v-model="place.UF_MONOGOROD_ID"
          class="sel-dropdown i-main-style i-wid-29"
          :disabled="$parent.$parent.projectDisabled"
        >
          <option value=""></option>
          <option
            v-for="item in $parent.directory.sp_monogorod"
            v-bind:value="item.ID"
            v-bind:key="item.ID"
            v-text="item.NAME"
            v-if="item.ID_REGION === place.UF_REGION_ID"
          ></option>
        </select>
        <!--
        <div class="error-text">
          {{
            $parent.$parent.checkErrorText("PROJECTS", "LOGIC", "UF_MONOGOROD_ID")
          }}
        </div>
        -->
      </div>
      <div style="clear: both"></div>
      <br />
      <a class="link-delete-row" v-on:click="deleteItem(index)"
        >&nbsp;&nbsp;&nbsp;&nbsp;Удалить</a
      >
      <hr />
      <div style="clear: both"></div>
    </div>
    <div
      style="text-align: left; display: flex; align-items: center; gap: 10px"
      class="add-row uf_name"
      v-if="showDop && !$parent.$parent.projectDisabled"
    >
      <span>
        <div style="clear: both"></div>
        <br />
        <a class="link-add-row" @click="addItem">
          {{ addLabel }}
        </a>
      </span>
      <!--   начало блока подсказки   -->
      <VDropdown trigger="click" placement="bottom" popperClass="custom-popper">
        <a class="info-holder-icon" />
        <template #popper>
          <span
            v-if="
              $parent.project.UF_HELP.FIELDS &&
                $parent.project.UF_HELP.FIELDS.STEP2 &&
                $parent.project.UF_HELP.FIELDS.STEP2.DOP_PLACE_ADD
            "
          >
            {{ $parent.project.UF_HELP.FIELDS.STEP2.DOP_PLACE_ADD }}
          </span>
          <span v-else>
            Укажите дополнительное место реализации проекта, если
            производственные площадки находятся в разных населенных пунктах
          </span>
        </template>
      </VDropdown>
      <!--   конец блока подсказки   -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Dropdown as VDropdown } from "floating-vue";

export default {
  name: "place",
  components: {
    VDropdown
  },
  // Блоки основного и дополнительного места можно рендерить по отдельности —
  // в программах, где это разные пункты резюме («Лизинг судов»).
  props: {
    showMain: {
      type: Boolean,
      default: true
    },
    showDop: {
      type: Boolean,
      default: true
    },
    mainLabel: {
      type: String,
      default: "Основное место реализации проекта:"
    },
    dopLabel: {
      type: String,
      default: "Дополнительное место реализации проекта:"
    },
    dopRowLabel: {
      type: String,
      default: "Место реализации проекта:"
    },
    addLabel: {
      type: String,
      default: "Добавить место реализации проекта"
    }
  },
  computed: {
    ...mapGetters(["project"]),
    dopPlaces() {
      const dopPlace = this.project.DOP_PLACE_RELISE;
      return dopPlace && Array.isArray(dopPlace.items) ? dopPlace.items : [];
    },
    dopPlacesVisible() {
      return this.showDop ? this.dopPlaces : [];
    }
  },
  methods: {
    addItem() {
      const dopPlace = this.project.DOP_PLACE_RELISE;
      // бэкенд для части программ отдаёт пустой массив вместо { items: [] }
      if (!dopPlace || !Array.isArray(dopPlace.items)) {
        this.$set(this.project, "DOP_PLACE_RELISE", { items: [] });
      }
      this.project.DOP_PLACE_RELISE.items.push({});
    },
    deleteItem(index) {
      this.project.DOP_PLACE_RELISE.items.splice(index, 1);
    }
  }
};
</script>

<style scoped></style>
